import { InitiativeStatus } from 'legacy/lut/classes/models/partner360/IFormThingsToImprove'
import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'
import { TKeyInitiative } from 'partner360/entities/keyInitiatives'
import { TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'

import { KpiProgressBar } from '../common/kpiProgressBar/KpiProgressBar'
import { KpiTile } from '../common/kpiTile/KpiTile'

interface IDoneInitiativesProps {
  kiData: TKeyInitiative[]
}

export const DoneInitiatives = ({ kiData }: IDoneInitiativesProps) => {
  const { totalCount, doneCount, donePercent } = useMemo(() => {
    const totalCount = kiData.length

    const doneCount = kiData.filter((item) => item.Status === InitiativeStatus.Done).length

    const donePercent = totalCount ? Math.round((doneCount / totalCount) * 100) : 0

    return {
      totalCount,
      doneCount,
      donePercent,
    }
  }, [kiData])

  return (
    <KpiTile
      title={TRANSLATION_KEYS.dashboard.aggregatedView.done.title}
      value={`${donePercent}%`}
      footer={
        <KpiProgressBar
          label={
            <Translation
              text={TRANSLATION_KEYS.dashboard.aggregatedView.done.footer}
              replaceParams={[
                { key: '{doneCount}', value: String(doneCount) },
                { key: '{totalCount}', value: String(totalCount) },
              ]}
              span
            />
          }
          target={totalCount}
          value={doneCount}
        />
      }
    />
  )
}
